<template>
  <div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Collaborator's email address</label>
          <b-form-input
              type="email"
              :state="informationValidation.isCollaboratorEmailProvided && informationValidation.isCollaboratorEmailValid && !isCollaboratorEmailAlreadyInvited && isCollaboratorEmailRegistered && isCurrentEmailProvided"
              v-model="collaboratorEmail"></b-form-input>

          <b-form-invalid-feedback v-if="!informationValidation.isCollaboratorEmailProvided">
            This field must not be empty
          </b-form-invalid-feedback>

          <b-form-invalid-feedback v-else-if="!informationValidation.isCollaboratorEmailValid">
            Please provide a valid email address
          </b-form-invalid-feedback>

          <b-form-invalid-feedback v-else-if="isCurrentEmailProvided">
            You are one of the list collaborators
          </b-form-invalid-feedback>

          <b-form-invalid-feedback v-else-if="isCollaboratorEmailAlreadyInvited">
            The collaborator has been included in the list
          </b-form-invalid-feedback>

          <b-form-invalid-feedback v-else-if="!isCollaboratorEmailRegistered">
            The email address provided is not registered in the system
          </b-form-invalid-feedback>

          <b-form-text>Only registered email address will be invited to the list.</b-form-text>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Set collaborators's role</label>
          <b-form-select v-model="roleSelected" :options="roleOptions"></b-form-select>
        </b-col>
      </b-row>
    </div>
    <div class="input-container">
      <b-row>
        <b-col>
          <b-button class="secondary-input-button" block @click="inviteCollaborator">Invite collaborator</b-button>
        </b-col>
      </b-row>
    </div>
    <hr>
    <div class="input-container">
      <b-row>
        <b-col>
          <label class="input-title">Collaborators</label>
          <div class="collaborator-container">
            <invite-new-collaborator-list-cell
                v-for="(collaborator, index) in collaboratorToBeInvited.currentCollaboratorListArray"
                :key="collaborator.id" :user-details="collaborator"
                :user-role="collaboratorToBeInvited.currentCollaboratorRoleArray[index]"></invite-new-collaborator-list-cell>
            <p v-if="!informationValidation.isCollaboratorListValid && informationValidation.isCollaboratorListValid !== null"
               class="invalid-text">Please invite at least 1 collaborator to the list.</p>
          </div>
        </b-col>
      </b-row>
    </div>
    <hr>
    <b-button class="main-input-button" block @click="confirmInvitation">Confirm invitation</b-button>
  </div>
</template>

<script>
  import {email, required} from "vuelidate/lib/validators";
  import InviteNewCollaboratorListCell from "../table_cells/collaborator_cell/InviteNewCollaboratorListCell";
  import {db} from "../../main";
  import {mapGetters} from "vuex";

  export default {
    name: "InviteListCollaborator.vue",
    components: {
      InviteNewCollaboratorListCell
    },
    data() {
      return {
        collaboratorToBeInvited: {
          toDoListId: null,
          toDoListName: null,
          currentToDoListCollaboratorId: [],
          currentCollaboratorListArray: [],
          currentCollaboratorEmailArray: [],
          currentCollaboratorRoleArray: []
        },
        informationValidation: {
          isCollaboratorEmailProvided: null,
          isCollaboratorEmailValid: null,
          isCollaboratorListValid: null,
        },
        collaboratorEmail: null,
        isCurrentEmailProvided: null,
        isCollaboratorEmailRegistered: null,
        isCollaboratorEmailAlreadyInvited: null,
        invitedCollaboratorEmailArray: [],
        roleSelected: 'Administrator',
        roleOptions: [
          {value: 'Administrator', text: 'Administrator'},
          {value: 'Member', text: 'Member'},
        ]
      }
    },
    validations: {
      collaboratorEmail: {
        required,
        email
      },
      collaboratorToBeInvited: {
        currentCollaboratorEmailArray: {
          required
        }
      }
    },
    methods: {
      inviteCollaborator() {
        // check if all information is valid
        let isValid = true
        this.informationValidation.isCollaboratorListValid = null

        if (!this.$v.collaboratorEmail.required) {
          this.informationValidation.isCollaboratorEmailProvided = false
          isValid = false
        } else {
          this.informationValidation.isCollaboratorEmailProvided = true
        }

        if (!this.$v.collaboratorEmail.email) {
          this.informationValidation.isCollaboratorEmailValid = false
          isValid = false
        } else {
          this.informationValidation.isCollaboratorEmailValid = true
        }

        // check if the user provide their own email address
        if (this.collaboratorEmail === this.$store.getters.user.data.email) {
          this.isCurrentEmailProvided = true
          isValid = false
        } else {
          this.isCurrentEmailProvided = false
        }

        // check if the email address has been invited to the collaborative list
        if (this.invitedCollaboratorEmailArray.includes(this.collaboratorEmail)) {
          this.isCollaboratorEmailAlreadyInvited = true
          isValid = false
        } else {
          this.isCollaboratorEmailAlreadyInvited = false
        }

        if (isValid) {
          this.isCollaboratorEmailAlreadyInvited = false

          db
            .collection('users/')
            .where('email', '==', this.collaboratorEmail)
            .get()
            .then(querySnapshot => {
              const userObject = querySnapshot.docs.map(doc => doc.data())
              // check whether the user is registered in the database
              if (userObject.length !== 0) {
                const collaboratorObject = userObject[0]

                this.collaboratorToBeInvited.currentCollaboratorListArray.push(collaboratorObject)
                this.collaboratorToBeInvited.currentCollaboratorEmailArray.push(collaboratorObject.email)
                this.collaboratorToBeInvited.currentCollaboratorRoleArray.push(this.roleSelected)
                this.collaboratorToBeInvited.currentToDoListCollaboratorId.push(collaboratorObject.id)

                this.collaboratorEmail = null
                this.informationValidation.isCollaboratorEmailProvided = null
                this.informationValidation.isCollaboratorEmailValid = null
                this.isCurrentEmailProvided = null
                this.isCollaboratorEmailRegistered = null
                this.isCollaboratorEmailAlreadyInvited = null
              } else {
                this.isCollaboratorEmailRegistered = false
              }
            })
        }
      },
      confirmInvitation() {
        // check if all information is valid
        let isValid = true
        this.informationValidation.isCollaboratorEmailProvided = null
        this.informationValidation.isCollaboratorEmailValid = null

        if (!this.$v.collaboratorToBeInvited.currentCollaboratorEmailArray.required) {
          this.informationValidation.isCollaboratorListValid = false
          isValid = false
        } else {
          this.informationValidation.isCollaboratorListValid = true
        }

        if (isValid) {
          this.$store.dispatch('inviteAdditionalCollaborator', this.collaboratorToBeInvited)
          this.hideModal('creation-modal')
        }
      },
      hideModal(id) {
        this.$root.$emit('bv::hide::modal', id)
      }
    },
    computed: {
      ...mapGetters([
        "removedFromInvitationCollaboratorObject"
      ])
    },
    watch: {
      removedFromInvitationCollaboratorObject(newCollaboratorObject, oldCollaboratorObject) {
        if (newCollaboratorObject.id !== null) {
          const collaboratorIdToBeRemoved = newCollaboratorObject.id

          // find the index of the collaborator in the array to be removed
          const collaboratorIndex = this.collaboratorToBeInvited.currentToDoListCollaboratorId.indexOf(collaboratorIdToBeRemoved)

          if (collaboratorIndex > -1) {
            this.collaboratorToBeInvited.currentCollaboratorListArray.splice(collaboratorIndex, 1)
            this.collaboratorToBeInvited.currentCollaboratorEmailArray.splice(collaboratorIndex, 1)
            this.collaboratorToBeInvited.currentCollaboratorRoleArray.splice(collaboratorIndex, 1)
            this.collaboratorToBeInvited.currentToDoListCollaboratorId.splice(collaboratorIndex, 1)
          }
        }
      },
    },
    mounted() {
      this.collaboratorToBeInvited.toDoListId = this.$route.params.collaborativeListId

      db
        .collection('collaborative_to_do_lists/')
        .doc(this.collaboratorToBeInvited.toDoListId)
        .onSnapshot(doc => {
          this.toDoListDetails = doc.data()
          this.collaboratorToBeInvited.toDoListName = this.toDoListDetails.toDoListName
        })

      db
        .collectionGroup('user_collaborative_to_do_list_participation')
        .where('collaborativeToDoListId', '==', this.collaboratorToBeInvited.toDoListId)
        .onSnapshot(querySnapshot => {
          querySnapshot.docs.map(doc => {
            this.invitedCollaboratorEmailArray.push(doc.data().collaboratorEmail)
          })
        })

      this.$store.dispatch('setRemovedFromInvitationCollaboratorObject', null)
    },
    destroyed() {
      this.$store.dispatch('setRemovedFromInvitationCollaboratorObject', null)
    }
  }
</script>

<style scoped>
  .section-title {
    font-size: 1.5em;
    margin-bottom: 0.5em;
  }

  .collaborator-container {
    height: 25vh;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .input-container {
    margin-bottom: 1em;
  }

  .input-title {
    font-weight: bold;
  }

  .main-input-button {
    font-weight: bold;
    background-color: #212441;
    padding: 0.5em;
  }

  .main-input-button:hover {
    font-weight: bold;
    background-color: #FFFFFF;
    color: #212441;
    padding: 0.5em;
  }

  .secondary-input-button {
    background-color: white;
    color: #212441;
    padding: 0.5em;
  }

  .secondary-input-button:hover {
    background-color: #212441;
    color: white;
    padding: 0.5em;
  }

  .invalid-text {
    color: red;
    text-align: center;
  }
</style>
